<div class="table-container">
  <div class="table-container__actions">
    <mat-form-field class="package-search" appearance="outline" subscriptSizing="dynamic">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput type="text" [(ngModel)]="searchInput" (keyup)="applySearch($any($event.target).value)" [placeholder]="'app.misc.search' | translate" />
      @if (searchInput) {
        <button type="button" mat-icon-button matSuffix aria-label="Clear" (click)="applySearch('')"><mat-icon>close</mat-icon></button>
      }
    </mat-form-field>
    <button type="button" mat-raised-button class="package-add-button" (click)="onAddCustomPackage()" [disabled]="!enableAdd">
      <mat-icon>add_circle</mat-icon><span>{{ "app.customPackages.addCustomPackage" | translate }}</span>
    </button>
  </div>
  <div class="package-table-area">
    <div class="package-table-scroll">
  <mat-table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="PAC_Name">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "app.customPackages.name" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row" [attr.data-label]="'app.customPackages.name' | translate">
        @if (row.PAC_Action != "UPDATE" && row.PAC_Action != "ADD") {
          <span class="dots">
            {{ row.PAC_Name }}
          </span>
        }
        @if (row.PAC_Action == "UPDATE" || row.PAC_Action == "ADD") {
          <mat-form-field appearance="outline">
            <mat-label>{{ "app.customPackages.name" | translate }}</mat-label>
            <input
              matInput
              required
              maxlength="100"
              id="{{ row.PAC_Name }}"
              [(ngModel)]="row.PAC_Name"
              [ngModelOptions]="{ standalone: true }"
              name="{{ row.PAC_Name }}"
              autocomplete="customPackages"
              placeholder=" {{ 'app.customPackages.name' | translate }}"
            />
          </mat-form-field>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="PAC_PackageType">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "app.customPackages.packageType" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row" [attr.data-label]="'app.customPackages.packageType' | translate">
        @if (row.PAC_Action != "UPDATE" && row.PAC_Action != "ADD") {
          <span class="dots">
            {{ getPackageTypeName(row.PAC_PackageType) }}
          </span>
        }
        @if (row.PAC_Action == "UPDATE" || row.PAC_Action == "ADD") {
          <mat-form-field appearance="outline">
            <mat-label> {{ "app.customPackages.packageType" | translate }}</mat-label>
            <mat-select [(ngModel)]="row.PAC_PackageType">
              @for (pacType of packageTypes; track pacType) {
                <mat-option [value]="pacType.code">{{ pacType.name | translate }} </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="PAC_Description">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "app.customPackages.description" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row" [attr.data-label]="'app.customPackages.description' | translate">
        @if (row.PAC_Action != "UPDATE" && row.PAC_Action != "ADD") {
          <span class="dots">
            {{ row.PAC_Description }}
          </span>
        }
        @if (row.PAC_Action == "UPDATE" || row.PAC_Action == "ADD") {
          <mat-form-field appearance="outline">
            <mat-label>{{ "app.customPackages.description" | translate }}</mat-label>
            <input
              matInput
              maxlength="200"
              id="{{ row.PAC_Description }}"
              [(ngModel)]="row.PAC_Description"
              [ngModelOptions]="{ standalone: true }"
              name="{{ row.PAC_Description }}"
              autocomplete="customPackages"
              placeholder=" {{ 'app.customPackages.description' | translate }}"
            />
          </mat-form-field>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="PAC_Quantity">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "app.customPackages.quantity" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row" [attr.data-label]="'app.customPackages.quantity' | translate">
        @if (row.PAC_Action != "UPDATE" && row.PAC_Action != "ADD") {
          <span class="dots">
            {{ row.PAC_Quantity }}
          </span>
        }
        @if (row.PAC_Action == "UPDATE" || row.PAC_Action == "ADD") {
          <mat-form-field appearance="outline">
            <mat-label>{{ "app.customPackages.quantity" | translate }}</mat-label>
            <input
              matInput
              id="{{ row.PAC_Quantity }}"
              [(ngModel)]="row.PAC_Quantity"
              [ngModelOptions]="{ standalone: true }"
              name="{{ row.PAC_Quantity }}"
              autocomplete="customPackages"
              class="text-right-align"
              type="text"
              pattern="[0-9.]*"
              placeholder="{{ 'app.customPackages.quantity' | translate }}"
            />
          </mat-form-field>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="PAC_Length">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "app.customPackages.depth" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row" [attr.data-label]="'app.customPackages.depth' | translate">
        @if (row.PAC_Action != "UPDATE" && row.PAC_Action != "ADD") {
          <span class="dots">
            {{ row.PAC_Length }}
          </span>
        }
        @if (row.PAC_Action == "UPDATE" || row.PAC_Action == "ADD") {
          <mat-form-field appearance="outline">
            <mat-label>{{ "app.customPackages.depth" | translate }}</mat-label>
            @if (row.UnitOfMeasure == 0) {
              <span matSuffix>&nbsp;cm&nbsp;</span>
            }
            @if (row.UnitOfMeasure == 1) {
              <span matSuffix>&nbsp;in&nbsp;</span>
            }
            <input
              matInput
              id="{{ row.PAC_Length }}"
              [(ngModel)]="row.PAC_Length"
              [ngModelOptions]="{ standalone: true }"
              name="{{ row.PAC_Length }}"
              autocomplete="customPackages"
              class="text-right-align"
              type="text"
              pattern="[0-9.]*"
              placeholder="{{ 'app.customPackages.depth' | translate }}"
            />
          </mat-form-field>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="PAC_Width">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "app.customPackages.width" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row" [attr.data-label]="'app.customPackages.width' | translate">
        @if (row.PAC_Action != "UPDATE" && row.PAC_Action != "ADD") {
          <span class="dots">
            {{ row.PAC_Width }}
          </span>
        }
        @if (row.PAC_Action == "UPDATE" || row.PAC_Action == "ADD") {
          <mat-form-field appearance="outline">
            <mat-label>{{ "app.customPackages.width" | translate }}</mat-label>
            @if (row.UnitOfMeasure == 0) {
              <span matSuffix>&nbsp;cm&nbsp;</span>
            }
            @if (row.UnitOfMeasure == 1) {
              <span matSuffix>&nbsp;in&nbsp;</span>
            }
            <input
              matInput
              id="{{ row.PAC_Width }}"
              [(ngModel)]="row.PAC_Width"
              [ngModelOptions]="{ standalone: true }"
              name="{{ row.PAC_Width }}"
              autocomplete="customPackages"
              class="text-right-align"
              type="text"
              pattern="[0-9.]*"
              placeholder="{{ 'app.customPackages.width' | translate }}"
            />
          </mat-form-field>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="PAC_Height">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "app.customPackages.height" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row" [attr.data-label]="'app.customPackages.height' | translate">
        @if (row.PAC_Action != "UPDATE" && row.PAC_Action != "ADD") {
          <span class="dots">
            {{ row.PAC_Height }}
          </span>
        }
        @if (row.PAC_Action == "UPDATE" || row.PAC_Action == "ADD") {
          <mat-form-field appearance="outline">
            <mat-label>{{ "app.customPackages.height" | translate }}</mat-label>
            @if (row.UnitOfMeasure == 0) {
              <span matSuffix>&nbsp;cm&nbsp;</span>
            }
            @if (row.UnitOfMeasure == 1) {
              <span matSuffix>&nbsp;in&nbsp;</span>
            }
            <input
              matInput
              id="{{ row.PAC_Height }}"
              [(ngModel)]="row.PAC_Height"
              [ngModelOptions]="{ standalone: true }"
              name="{{ row.PAC_Height }}"
              autocomplete="customPackages"
              class="text-right-align"
              type="text"
              pattern="[0-9.]*"
              placeholder="{{ 'app.customPackages.height' | translate }}"
            />
          </mat-form-field>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="PAC_Weight">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "app.customPackages.weight" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row" [attr.data-label]="'app.customPackages.weight' | translate">
        @if (row.PAC_Action != "UPDATE" && row.PAC_Action != "ADD") {
          <span class="dots">
            {{ row.PAC_Weight }}
          </span>
        }
        @if (row.PAC_Action == "UPDATE" || row.PAC_Action == "ADD") {
          <mat-form-field appearance="outline">
            <mat-label>{{ "app.customPackages.weight" | translate }}</mat-label>
            @if (row.UnitOfMeasure == 0) {
              <span matSuffix>&nbsp;kg&nbsp;</span>
            }
            @if (row.UnitOfMeasure == 1) {
              <span matSuffix>&nbsp;lbs&nbsp;</span>
            }
            <input
              matInput
              id="{{ row.PAC_Weight }}"
              [(ngModel)]="row.PAC_Weight"
              [ngModelOptions]="{ standalone: true }"
              name="{{ row.PAC_Weight }}"
              autocomplete="customPackages"
              class="text-right-align"
              type="text"
              pattern="[0-9.]*"
              placeholder="{{ 'app.customPackages.weight' | translate }}"
              (change)="validateDryIceWeight(row)"
            />
          </mat-form-field>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="PAC_DryIceWeight">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "app.customPackages.dryIceWeight" | translate }}
      </mat-header-cell>
      <mat-cell *matCellDef="let row" [attr.data-label]="'app.customPackages.dryIceWeight' | translate">
        @if (row.PAC_Action != "UPDATE" && row.PAC_Action != "ADD") {
          <span class="dots">
            {{ row.PAC_DryIceWeight }}
          </span>
        }
        @if (row.PAC_Action == "UPDATE" || row.PAC_Action == "ADD") {
          <mat-form-field appearance="outline">
            <mat-label>{{ "app.customPackages.dryIceWeight" | translate }}</mat-label>
            @if (row.UnitOfMeasure == 0) {
              <span matSuffix>&nbsp;kg&nbsp;</span>
            }
            @if (row.UnitOfMeasure == 1) {
              <span matSuffix>&nbsp;lbs&nbsp;</span>
            }
            <input
              matInput
              id="{{ row.PAC_DryIceWeight }}"
              [(ngModel)]="row.PAC_DryIceWeight"
              [ngModelOptions]="{ standalone: true }"
              name="{{ row.PAC_DryIceWeight }}"
              autocomplete="customPackages"
              class="text-right-align"
              type="text"
              pattern="[0-9.]*"
              placeholder="{{ 'app.customPackages.dryIceWeight' | translate }}"
              (change)="validateDryIceWeight(row)"
            />
          </mat-form-field>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="UnitOfMeasure">
      <mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ "app.misc.unitOfMeasure" | translate }}
      </mat-header-cell>
      <mat-cell
        *matCellDef="let row"
        [attr.data-label]="'app.misc.unitOfMeasure' | translate"
       
      >
        @if (row.PAC_Action != "UPDATE" && row.PAC_Action != "ADD") {
          <span class="dots">
            {{ getUOMName(row.UnitOfMeasure) }}
          </span>
        }
        @if (row.PAC_Action == "UPDATE" || row.PAC_Action == "ADD") {
          <mat-form-field appearance="outline">
            <mat-label> {{ "app.misc.unitOfMeasure" | translate }}*</mat-label>
            <mat-select [(ngModel)]="row.UnitOfMeasure">
              @for (measure of measures; track measure) {
                <mat-option [value]="measure.code">{{ measure.name | translate }} </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef>Actions</mat-header-cell>
      <mat-cell *matCellDef="let row" class="package-actions-cell">
        @if (row.PAC_Action == "UPDATE" || row.PAC_Action == "ADD") {
          <div class="package-row-actions">
            <button type="button" mat-icon-button class="package-icon-button cancel" [matTooltip]="'app.misc.cancel' | translate" (click)="onCancel(row)"><mat-icon>close</mat-icon></button>
            <button type="button" mat-icon-button class="package-icon-button save" [matTooltip]="'app.misc.save' | translate" (click)="onSaveCustomPackage(row)"><mat-icon>save</mat-icon></button>
          </div>
        } @else {
          <div class="package-row-actions">
            <button type="button" mat-icon-button class="package-icon-button edit" [matTooltip]="'app.misc.edit' | translate" (click)="onModifyCustomPackage(row)"><mat-icon>edit</mat-icon></button>
            <button type="button" mat-icon-button class="package-icon-button delete" [matTooltip]="'app.misc.delete' | translate" (click)="onRemoveCustomPackage(row)"><mat-icon>delete</mat-icon></button>
          </div>
        }
      </mat-cell>
    </ng-container>

    <!-- Table header definition -->
    <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"> </mat-header-row>

    <!-- Table row definition -->
    <mat-row *matRowDef="let row; columns: displayedColumns"> </mat-row>
  </mat-table>
    </div>
    @if (!isProcessing && dataSource.filteredData.length === 0) {
      <div class="package-empty">
        <div class="package-empty-icon"><mat-icon>inventory_2</mat-icon></div>
        <h2>{{ "app.customPackages.title" | translate }}</h2>
        <p>{{ "app.misc.search" | translate }} — 0</p>
      </div>
    }
    <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
  </div>
</div>

<!-- The overlay to display when the page is processing something -->
@if (isProcessing) {
  <app-processing-overlay [message]="'app.misc.processing' | translate"> </app-processing-overlay>
}
